import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export const messageToastLogin = (
  message: any,
  navigateForogotPassword: () => void,
  navigateFirstLogin: () => void
) => {
  if (message) {
    if (message === "Verifique Email e Senha e tente novamente.") {
      return (
        <Flex direction="column" lineHeight={"5"}>
          Caso tenha esquecido seus dados de acesso, clique no link{" "}
          <Text
            as="span"
            color={"white"}
            textDecoration="underline"
            cursor="pointer"
            w="fit-content"
            onClick={() => {
              navigateForogotPassword();
            }}
          >
            Esqueceu sua senha.
          </Text>
        </Flex>
      );
    } else if (
      message === "Erro interno ao autenticar." ||
      message === "O usuário não está autorizado a entrar no BoraVender."
    ) {
      return (
        <Flex direction="column" lineHeight={"5"}>
          {message}
        </Flex>
      );
    } else if (
      message ===
      "Se deseja fazer parte do time de vendas, entre em contato pelo link "
    ) {
      return (
        <Flex direction="column" lineHeight={"5"}>
          <Text>
            Se deseja fazer parte do time de vendas, entre em contato pelo link{" "}
            <Text
              as="span"
              color={"white"}
              textDecoration="underline"
              cursor="pointer"
              w="fit-content"
            >
              <Link to="/needHelp">Precisa de ajuda?</Link>
            </Text>
          </Text>
        </Flex>
      );
    } else if (
      message ===
      "Seus dados cadastrais foram atualizados no nosso sistema. Por isso, será necessário que você clique no link "
    ) {
      <Flex direction="column" lineHeight={"5"}>
        Seus dados cadastrais foram atualizados no nosso sistema. Por isso, será
        necessário que você clique no link{" "}
        <Text
          as="span"
          color={"white"}
          textDecoration="underline"
          cursor="pointer"
          w="fit-content"
          onClick={() => {
            navigateFirstLogin();
          }}
        >
          Primeiro acesso.
        </Text>
      </Flex>;
    } else {
      return <Text color={"white"}>{message}</Text>;
    }
  } else {
    return (
      <Text color={"white"}>
        Caso não lembre seus dados ou tenha alguma dúvida entre em contato pelo{" "}
        <Link to="/needHelp">Precisa de ajuda?</Link>
      </Text>
    );
  }
};
